import { useMemo } from "react";
import { useGlobalFilter, usePagination, useSortBy, useTable } from "react-table";

import { formatMilesDecimalNew } from "@/services/Utils";

import classes from "./reactTable.module.scss";

const DetailTable = ({ detailColumns, data, hiddenColumns }) => {
	const customizedColumns = useMemo(() => {
		return detailColumns.map((column) => {
			if (Object.prototype.hasOwnProperty.call(column, "format") && column.format === "decimal") {
				return {
					...column,
					Cell: ({ value }) => {
						return <div>{formatMilesDecimalNew(String(value).replace(".", ","))}</div>;
					},
				};
			}

			return column;
		});
	}, [detailColumns]);

	// eslint-disable-next-line
	const columns = useMemo(() => customizedColumns, []);

	const tableInstance = useTable(
		{
			columns: columns,
			data: data.items,
			initialState: {
				hiddenColumns: hiddenColumns ? hiddenColumns : [],
			},
		},
		useGlobalFilter,
		useSortBy,
		usePagination,
	);

	const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } = tableInstance;

	if (detailColumns.length === 0) {
		return null;
	}

	if (!data.active) {
		return null;
	}

	return (
		<tr className={classes.table_detail}>
			<td colSpan={12} className={classes.td_table}>
				<table {...getTableProps()} className={classes.table_item}>
					<thead>
						{headerGroups.map((headerGroup) => (
							<tr {...headerGroup.getHeaderGroupProps()} className={classes.table_item_tr}>
								{headerGroup.headers.map((column) => (
									<th {...column.getHeaderProps()} className={classes.th_detail} style={{ width: "2%" }}>
										{column.render("Header")}
									</th>
								))}
							</tr>
						))}
					</thead>
					<tbody {...getTableBodyProps()}>
						{rows.map((row, _i) => {
							prepareRow(row);
							return (
								<tr {...row.getRowProps()} className={`${classes.table_item_tr}`}>
									{row.cells.map((cell) => {
										return (
											<td {...cell.getCellProps()} className={`${classes.table_item_td} ${row.index === 0 && classes.first_td}`}>
												<div
													className={`${classes.div_item} ${
														row.index === 0
															? classes.first_div
															: row.index === rows.length - 1 && rows.length !== 0
																? classes.last_div
																: ""
													}`}
												>
													{cell.render("Cell")}
												</div>
											</td>
										);
									})}
								</tr>
							);
						})}
					</tbody>
				</table>
			</td>
		</tr>
	);
};

export default DetailTable;
